export default "__VITE_ASSET__Dwh6uMHG__"